<div class="d-flex gap-s card-heading">
  <pr-icon
    *ngIf="icon"
    [name]="icon.name"
    [width]="icon.width || 16"
    [height]="icon.height || icon.width || 16"
    [viewBoxWidth]="icon.viewBoxWidth || 16"
    [viewBoxHeight]="icon.viewBoxHeight || icon.viewBoxWidth || 16"
    [ngClass]="{
      'text-success-dark bg-success-light': display == 'success',
      'text-warning-dark bg-warning-light': display == 'warning',
      'text-neutral-dark bg-neutral-light': display == 'neutral',
      'text-danger bg-danger-light': display == 'danger',
    }"
  >
  </pr-icon>
  <span class="text-600 text-black">
    {{ label }}
  </span>
</div>
<div
  class="full-w"
  [ngClass]="{ 'info-tooltip': tooltip }"
  [tooltip]="tooltip"
  containerClass="ea-tooltip ea-md"
  placement="bottom"
>
  <h3
    class="text-600"
    [ngClass]="{
      'text-success': display == 'success',
      'text-warning': display == 'warning',
      'text-neutral': display == 'neutral',
      'text-danger': display == 'danger',
    }"
  >
    <ng-container [ngSwitch]="true">
      <ng-container *ngSwitchCase="value === undefined"> - </ng-container>
      <ng-container *ngSwitchDefault>
        <ng-container [ngSwitch]="type">
          <em *ngSwitchCase="PrCardType.PERCENT">{{
            value | percent: '.2'
          }}</em>
          <em *ngSwitchCase="PrCardType.PERCENT_WITH_2_DECIMAL">{{
            value | percent: '.2'
          }}</em>
          <em *ngSwitchCase="PrCardType.EURO">{{
            value | currency: 'EUR' : 'symbol' : '.0-0'
          }}</em>
          <em *ngSwitchCase="PrCardType.HTML" [innerHTML]="value"></em>
          <em *ngSwitchCase="PrCardType.RISK_LEVEL_LADDER">
            <pr-risk-level-ladder [range]="value"></pr-risk-level-ladder>
          </em>
          <em
            *ngSwitchCase="PrCardType.SCORING"
            class="d-flex gap-s justify-content-flex-end align-items-center"
          >
            <div class="d-flex full-w card-scoring">
              <div
                *ngFor="let item of _.range(5); let i = index"
                [attr.active]="i + 1 <= Math.round(value / 4)"
                [class]="
                  (value <= 13
                    ? value <= 7
                      ? 'danger'
                      : 'warning'
                    : 'success') + '_filled'
                "
              ></div>
            </div>
            <span
              class="fs-16"
              [class]="
                'text-' +
                (value <= 13 ? (value <= 7 ? 'danger' : 'warning') : 'success')
              "
              >{{ value | number: '.0-0' }} / 20</span
            >
          </em>
          <em *ngSwitchDefault>{{ value }}</em>
        </ng-container>
      </ng-container>
      <span *ngIf="sublabel" class="sublabel fw-500 fs-16">
        / {{ sublabel | currency: 'EUR' : 'symbol' : '.0-0' }}</span
      >
      <span *ngIf="subvalue" class="subvaluel fw-700"> {{ subvalue }}</span>
    </ng-container>
  </h3>
</div>
